import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CommentTiptapEditor from '@wix/da-editor-tiptap/pkg/components/Editor/presets/Comment';
import useEditorNg from '../DaEditorNg/hooks/useEditorNg';
import EditorCommon from '../DaEditorNg/EditorCommon';
import { CommentEditorContext } from './context';
import { CommentEditorSource } from '../CommentEditor/redux/types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
const CommentEditor = /*#__PURE__*/ React.memo((props)=>{
    const { onChange, className, loadingIndicator, placeholder, onEditorReady } = props;
    const { t } = useTranslation();
    const { initialContent, editorSource, rootElementRef } = useContext(CommentEditorContext);
    const { editorProps, editorSharedProps, editorCommonProps } = useEditorNg({
        onEditorChange: onChange,
        onEditorReady: onEditorReady
    });
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "CommentEditor"
    }, /*#__PURE__*/ React.createElement(EditorCommon, editorCommonProps), /*#__PURE__*/ React.createElement(CommentTiptapEditor, _object_spread_props(_object_spread({}, editorSharedProps, editorProps), {
        rootElementRef: rootElementRef,
        className: className,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : editorSource === CommentEditorSource.Reply ? t('commentbox.editor.placeholder.reply') : t('commentbox.editor.placeholder'),
        cookieType: undefined,
        loadingIndicator: loadingIndicator,
        initialContent: initialContent
    })));
});
CommentEditor.displayName = 'SharedCommentEditor';
export default CommentEditor;

//# sourceMappingURL=CommentEditor.js.map